import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UserProfileService {
  private userImgSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public currentUserImg = this.userImgSource.asObservable();

  private userUserFirstNameSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public currentUserFirstName = this.userUserFirstNameSource.asObservable();

  private userUserLastNameSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public currentUserLastName = this.userUserLastNameSource.asObservable();

  constructor() { }

  public changeUserImg(img: string) {
    this.userImgSource.next(img);
  }

  public changeUserFirstName(firstName: string) {
    this.userUserFirstNameSource.next(firstName);
  }

  public changeUserLastName(lastName: string) {
    this.userUserLastNameSource.next(lastName);
  }
  
}
